import axios from "axios";
import TextcontrolService from "../textcontrol-header";

const API_URL = process.env.REACT_APP_API_URL_Textcontrol + "document/";

class DocumentService {
  async loadDocument(jobDetails) {
    const res = await TextcontrolService.getAuthHeader();
    const headers = { AUTHKEY: res.data };
    return axios.post(API_URL + "load", jobDetails, { headers });
  }
}
const documentService = new DocumentService();
export default documentService;
